/* global location */
// import { initHomeSlider } from '@js/common/swiperInit.js';
import { initFancybox } from '@js/common/fancybox.js';

import { Fancybox } from '@fancyapps/ui';
// import '@fancyapps/ui/dist/fancybox.css';

import deviceMenu from '@js/common/deviceMenu.js';
import initMegamenu from '@js/modules/megamenu.js';
import {
    slideToggle,
    headeraddClass,
} from '@js/common/all-functions.js';
// const mainHeader = document.querySelector('.main-header');

deviceMenu();
headeraddClass();
// initHomeSlider();
initFancybox();
initMegamenu();
/* Script on ready
------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    /* Process buttons */
    // document.querySelectorAll('.btn-link, .btn-play').forEach(function (element) {
    //     if (element.classList.contains('btn-link')) {
    //         appendSVGBtn(element, '#icon-btn-arrow', '24', '15');
    //     } else if (element.classList.contains('btn-play')) {
    //         appendSVGBtn(element, '#icon-play-btn', '10', '13');
    //     }
    // });
    /* Process buttons End */
    initFooterMenu();
    initMegamenu();
    /* Use jQuery code Start */
    (function($) {
        // Write code here

    })(jQuery);
    /* Use jQuery code End */
});

/* Script all functions
------------------------------------------------------------------------------*/
/* Footer menu start */
function initFooterMenu() {
    const footerLinks = document.querySelectorAll('.main-footer ul.menu > li.menu-item-has-children > a');

    footerLinks.forEach(link => {
        if (!link.querySelector('.down-arrow')) {
            const span = document.createElement('span');
            span.className = 'down-arrow';

            // Wrap the <a> tag and .down-arrow in a new div with class 'menu-item-wrap'
            const menuItemWrap = document.createElement('div');
            menuItemWrap.className = 'menu-item-wrap';
            link.parentNode.insertBefore(menuItemWrap, link);
            menuItemWrap.appendChild(link);
            menuItemWrap.appendChild(span);
        }
    });

    function attachEvents() {
        footerLinks.forEach(link => {
            const menuItem = link.closest('.menu-item');
            const subMenu = menuItem.querySelector('.sub-menu');
            const downArrow = link.parentNode.querySelector('.down-arrow');

            // Reset menu state
            if (subMenu) {
                subMenu.style.display = '';
            }
            menuItem.classList.remove('is-active');

            // Remove existing click listener to avoid duplicates
            downArrow?.replaceWith(downArrow.cloneNode(true));

            if (window.innerWidth < 767 && downArrow && subMenu) {
                const newDownArrow = link.parentNode.querySelector('.down-arrow');
                newDownArrow.addEventListener('click', function(e) {
                    e.stopPropagation();
                    menuItem.classList.toggle('is-active');
                    slideToggle(subMenu);
                });
            }
        });
    }

    attachEvents();
    window.addEventListener('resize', attachEvents);
}
/* Footer menu end */

/* Header add class only */
// function headeraddClass() {
//     if (!mainHeader) {return;}

//     const handleScroll = () => {
//         const currentScroll = window.scrollY;

//         if (currentScroll > 80) {
//             mainHeader.classList.add('scroll');
//         } else {
//             mainHeader.classList.remove('scroll');
//         }
//     };

//     // Bind scroll listener
//     window.addEventListener('scroll', handleScroll);
// }

jQuery(document).ready(function($) {
    $('.presence-tab').on('click', function(e) {
        e.preventDefault();

        const target = $(this).data('tab'); // e.g. "tab-0"

        // Switch active tab
        $('.presence-tab').removeClass('active');
        $(this).addClass('active');

        // Switch active content (CSS transition handles animation)
        $('.presence-content').removeClass('active');
        $('#' + target).addClass('active');
    });
    jQuery('.accordion-wrapper').each(function() {
        const accordionWrapper = jQuery(this);

        // Handle clicks only within this accordion
        accordionWrapper.find('.accordion-header').click(function() {
            const item = jQuery(this).closest('.accordion-item');
            const content = item.find('.accordion-content');

            if (item.hasClass('active')) {
                // Close if already open
                item.removeClass('active');
                content.stop(true, true).slideUp(300);
                jQuery(this).attr('aria-expanded', 'false');
            } else {
                // Close all open items in this accordion only
                accordionWrapper.find('.accordion-item.active')
                    .removeClass('active')
                    .find('.accordion-content')
                    .stop(true, true)
                    .slideUp(300)
                    .prev('.accordion-header')
                    .attr('aria-expanded', 'false');

                // Open the clicked one
                item.addClass('active');
                content.stop(true, true).slideDown(300);
                jQuery(this).attr('aria-expanded', 'true');
            }
        });
    });
    $('.global-presence-section .presence-tab').on('click', function() {
        const locationValue = $(this).data('tab-value');
        const currentUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
        const newUrl = currentUrl + '?location=' + encodeURIComponent(locationValue);
        history.pushState({ path: newUrl }, '', newUrl);
    });
});



jQuery(document).ready(function($) {

    const currentUrl = window.location.href;

    $('.dynamic-submenu li.no-sub a').each(function() {
        if (this.href === currentUrl) {
            $(this).closest('li.no-sub').addClass('active');
        }
    });

});



jQuery(document).ready(function($) {

    $(document).on('nfFormSubmitResponse', function(e, response) {
        $('.nf-error').remove();
    });
    $(document).on('submit', 'form', function(e) {
        const checkbox1 = $('#nf-field-12').is(':checked');
        const checkbox2 = $('#nf-field-44').is(':checked');

        // If neither checkbox is checked
        if (!checkbox1 && !checkbox2) {

            e.preventDefault();
            e.stopImmediatePropagation();

            // Show error message only once
            if (!$('.nf-error').length) {
                $('#nf-field-44-wrap').after(
                    '<div class="nf-error" style="color:red;margin-top:5px;">Please select at least one option.</div>',
                );
            }

            return false;
        }
    });

});

document.addEventListener('DOMContentLoaded', function() {

    document.querySelectorAll('.js-video').forEach(function(wrap) {

        const playBtn = wrap.querySelector('.js-play-btn');
        const thumb = wrap.querySelector('.vc-thumbnail');
        const video = wrap.querySelector('video');
        const iframe = wrap.querySelector('iframe');

        playBtn.addEventListener('click', function() {

            playBtn.style.display = 'none';
            if (thumb) { thumb.style.display = 'none'; }

            if (video) {
                video.currentTime = 0;
                video.play();
            }

            if (iframe) {
                iframe.src = iframe.dataset.src;
            }

        });

    });

});



document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.search-form').forEach(form => {
        form.addEventListener('submit', function(e) {
            e.stopPropagation();
        });
    });
});


document.addEventListener('click', function(e) {
    const link = e.target.closest('a');
    if (!link) {return;}

    if (link.getAttribute('href') === '#form') {
        e.preventDefault();

        Fancybox.show(
            [
                {
                    src: '#nf-popup-wrap',
                    type: 'inline',
                },
            ],
            {
                closeButton: true,
                dragToClose: false,

                // ✅ Control behavior properly
                backdropClick: true,   // outside click बंद
                keyboard: false,         // ESC allow
                trapFocus: true,
                autoFocus: false,

                on: {
                    close: () => {
                        document.body.classList.remove('hide-scrollbar');
                    },
                },
            },
        );
    }
});

document.addEventListener('click', (e) => {
    if (e.target.classList.contains('fancybox__backdrop')) {
        document.body.classList.remove('hide-scrollbar');
    }
});

(function($) {

    $(document).on('nfFormSubmitResponse', function(e, response) {

        // ❌ validation fail → do nothing
        if (response.response !== 'success') { return; }

        const $popup = $('.fancybox__content');

        // hide form
        $popup.find('#form').hide();

        // show thank you
        $('#thankyou-popup')
            .appendTo($popup)
            .show();

        Fancybox.getInstance()?.update();
    });

})(jQuery);

jQuery(document).ready(function($) {

    const targetNode = document.querySelector('#nf-popup-wrap');

    if (!targetNode) { return; }

    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function() {
            if ($('#nf-popup-wrap .thankyou-popup, #nf-popup-wrap .thankyou-inner').length) {

                $('#nf-popup-wrap .title-wrap').addClass('is-hidden');

                observer.disconnect();
            }
        });
    });

    observer.observe(targetNode, {
        childList: true,
        subtree: true,
    });

});


// jQuery(document).on('click', '.fancybox__backdrop', function() {
//     jQuery('.fancybox__container').addClass('is-backdrop-clicked');
// });

jQuery(document).on(
    'click',
    '.fancybox__backdrop, .is-close',
    function(e) {

        const $container = jQuery('.fancybox__container');


        if (jQuery(e.target).closest('#form').length) {
            return;
        }


        $container.removeClass('is-backdrop-clicked is-close-clicked');


        if (jQuery('.thankyou-popup:visible').length) {
            location.reload();
            return;
        }


        if (jQuery('#form:visible').length) {


            $container.addClass('is-backdrop-clicked');


            if (jQuery(e.target).closest('.is-close').length) {
                $container.addClass('is-close-clicked');
            }
        }
    },
);
// jQuery(document).on(
//     'click',
//     '.fancybox__backdrop, button.carousel__button.is-close',
//     function() {
//         jQuery('.fancybox__container').addClass('is-backdrop-clicked');
//     },
// );


jQuery(document).ready(function($) {

    // =========================
    // Set default active submenu item
    // =========================
    function setDefaultActive($mega) {
        if ($mega.find('.dynamic-submenu > li.active').length === 0) {
            $mega.find('.dynamic-submenu > li').first().addClass('active');
        }
    }

    $('.hover-mega.is-open').each(function() {
        setDefaultActive($(this));
    });

    // =========================
    // Menu toggle
    // =========================
    const menuItem = $('.navigation .menu-item-has-children');
    const dropdown = $('.hm-dropdown');

    // Toggle submenu on menu link click
    menuItem.children('a').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const parent = $(this).closest('.menu-item-has-children');

        // Close other menus
        menuItem.not(parent).removeClass('is-open');

        // Toggle current
        parent.toggleClass('is-open');

        // Set default active for this submenu
        setDefaultActive(parent);
    });

    // Click outside menu → close submenu
    $(document).on('click', function(e) {
        // Only close top-level menu items
        menuItem.each(function() {
            const $this = $(this);

            // Click outside this menu item & its dropdown
            if (!$this.is(e.target) && $this.has(e.target).length === 0) {
                $this.removeClass('is-open');
            }
        });
    });

    // Click inside dropdown → keep open
    dropdown.on('click', function(e) {
        e.stopPropagation();
    });


    $('.dynamic-submenu > li > a, .sub-submenu a').on('click', function(e) {
        e.stopPropagation();
    });

});


jQuery(document).ready(function($) {

    // Function to reload page if Thank You popup is visible
    function reloadIfThankYouOpen() {
        const $popup = $('.thankyou-popup');
        if ($popup.length && $popup.is(':visible')) {
            location.reload();
        }
    }

    // Fancybox backdrop click
    $(document).on('click', '.fancybox__backdrop', function(e) {
        // Only reload if thankyou-popup is visible
        reloadIfThankYouOpen();
    });

    // Carousel close button click
    $(document).on('click', '.carousel__button.is-close', function(e) {
        reloadIfThankYouOpen();
    });

    // Optional: Also detect when Fancybox closes via ESC or other triggers
    $(document).on('afterClose.fb', function(e, instance, slide) {
        reloadIfThankYouOpen();
    });

});




document.addEventListener('DOMContentLoaded', function() {

    document.querySelectorAll('li.no-sub').forEach(function(li) {

        const mainLink = li.querySelector(':scope > a');
        const leftSection = li.querySelector(':scope > .left-section');

        if (!mainLink || !leftSection) { return; }

        // Prevent duplicate run
        if (li.querySelector(':scope > h6')) { return; }

        const linkText = mainLink.textContent.trim();
        const linkUrl = mainLink.getAttribute('href');

        // 1️⃣ Create h6 and add as first child of li
        const h6 = document.createElement('h6');
        h6.textContent = linkText;
        li.insertBefore(h6, mainLink);

        // 2️⃣ Create new anchor inside left-section
        const newAnchor = document.createElement('a');
        newAnchor.textContent = linkText;
        newAnchor.href = linkUrl;

        leftSection.insertBefore(newAnchor, leftSection.firstChild);

        // 3️⃣ Remove original top-level link
        mainLink.remove();

    });

});

window.addEventListener('DOMContentLoaded', function() {

    const submenuLists = document.querySelectorAll('.hover-mega .dynamic-submenu');

    submenuLists.forEach(function(submenu) {

        submenu.addEventListener('click', function(e) {

            const li = e.target.closest('li.no-sub');
            if (!li) { return; }

            // remove active from siblings
            submenu.querySelectorAll('li.no-sub').forEach(function(item) {
                item.classList.remove('active');
            });

            // add active to clicked
            li.classList.add('active');

        });

    });

});


jQuery(document).ready(function($) {
    if (window.location.hash) {
        const hash = window.location.hash;

        setTimeout(function() {
            if ($(hash).length) {
                $('html, body').animate({
                    scrollTop: $(hash).offset().top,
                }, 800);
            }
        }, 300); // delay for page load
    }
});


jQuery(document).on('afterClose.fb', function() {
    if (jQuery('.thankyou-popup:visible').length) {
        setTimeout(() => {
            location.reload();
        }, 200);
    }
});